function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h120v120H0z"
}), React.createElement("path", {
  fill: "#C0C2CC",
  d: "M54.2 52.078l.04.04L70.882 68.76l.04.04L94.06 91.94a1.5 1.5 0 0 1-2.122 2.12l-5.56-5.56H33a7.5 7.5 0 0 1-7.5-7.5V48a7.5 7.5 0 0 1 7.5-7.5h5.379l-12.44-12.44a1.5 1.5 0 0 1 2.122-2.12l26.138 26.138zM83.378 85.5L69.972 72.094a13.501 13.501 0 1 1-19.066-19.066L41.38 43.5H33a4.5 4.5 0 0 0-4.5 4.5v33a4.5 4.5 0 0 0 4.5 4.5h50.379zM67.847 69.968L53.032 55.153a10.5 10.5 0 1 0 14.815 14.815zm.35-35.468H51a1.5 1.5 0 0 1 0-3h18c.502 0 .97.25 1.248.668l5.555 8.332H87a7.5 7.5 0 0 1 7.5 7.5v28.02a1.5 1.5 0 0 1-3 0V48a4.5 4.5 0 0 0-4.5-4.5H75a1.5 1.5 0 0 1-1.248-.668L68.197 34.5z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 120,
    height: 120
  }, props), _ref);
};

export default SvgComponent;